import React from 'react';
import { Chart } from 'primereact/chart';

interface ShiftDistributionData {
    amShift: number;
    pmShift: number;
    amPmCoverage: boolean;
}

interface ShiftDistributionProps {
    data: ShiftDistributionData;
}

const ShiftDistribution: React.FC<ShiftDistributionProps> = ({ data }) => {
    const chartData = {
        labels: ['AM Shift', 'PM Shift'],
        datasets: [
            {
                data: [data.amShift, data.pmShift],
                backgroundColor: ['#4A90E2', '#7ED4E6'],
                borderWidth: 0,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom' as const,
                labels: {
                    usePointStyle: true,
                    padding: 20,
                },
            },
        },
    };

    return (
        <div className="shift-distribution-card dashboard-card dashboard-card-wrapper coming-soon-card h-100">
            <div className="card-header d-flex align-items-center justify-content-between mb-3">
                <h5 className="card-title mb-0">
                    <i className="ri-time-line me-2"></i>
                    Shift Distribution
                </h5>
                <span className="text-muted">Today</span>
            </div>

            <div className="shift-content">
                <div className="chart-container mb-3" style={{ height: '200px' }}>
                    <Chart type="doughnut" data={chartData} options={options} />
                </div>

                <div className="shift-stats">
                    <div className="shift-coverage mb-3">
                        <div className="coverage-label text-muted mb-1">AM vs PM Coverage</div>
                        <div className="coverage-status">
                            {data.amPmCoverage && (
                                <span className="text-success">
                                    <i className="ri-checkbox-circle-fill me-1"></i>
                                    Full Coverage
                                </span>
                            )}
                        </div>
                    </div>

                    <div className="shift-breakdown">
                        <div className="shift-item d-flex justify-content-between mb-2">
                            <span className="shift-label">
                                <span className="shift-color am-shift me-2"></span>
                                AM Shift
                            </span>
                            <span className="fw-bold">{data.amShift}</span>
                        </div>
                        <div className="shift-item d-flex justify-content-between">
                            <span className="shift-label">
                                <span className="shift-color pm-shift me-2"></span>
                                PM Shift
                            </span>
                            <span className="fw-bold">{data.pmShift}</span>
                        </div>
                    </div>

                    <div className="am-pm-ratio mt-3 text-center">
                        <div className="ratio-label text-muted">AM/PM Ratio</div>
                        <div className="ratio-value fw-bold">{(data.amShift / data.pmShift).toFixed(2)}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShiftDistribution;
